import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { IPermission } from "../../types/backend";
import { callFetchPermission } from "../../config/api";

interface IState {
  isFetching: boolean;
  meta: {
    current: number;
    pageSize: number;
    pages: number;
    total: number;
  };
  result: IPermission[];
}

// first, create thunk
export const fetchPermission = createAsyncThunk(
  "permission/fetchPermission",
  async ({ query }: { query: string }) => {
    const response = await callFetchPermission(query);
    return response;
  }
);

const initialState: IState = {
  isFetching: true,
  meta: {
    current: 1,
    pageSize: 10,
    pages: 0,
    total: 0,
  },
  result: [],
};

export const permissionSlice = createSlice({
  name: "permission",
  initialState,
  reducers: {
    setActiveMenu: (state, action) => {},
  },

  extraReducers: (builder) => {
    builder.addCase(fetchPermission.pending, (state, action) => {
      state.isFetching = true;
    });
    builder.addCase(fetchPermission.rejected, (state, action) => {
      state.isFetching = false;
    });
    builder.addCase(fetchPermission.fulfilled, (state, action: any) => {
      if (action.payload && action.payload.data) {
        state.isFetching = false;
        state.meta = action.payload.data.meta;
        state.result = action.payload.data.result;
      }
    });
  },
});

export const { setActiveMenu } = permissionSlice.actions;

export default permissionSlice.reducer;
